<template>
  <PageNotFound v-if="product == '404'" />
  <div class="ProductPage" v-else>
      <div class="container">
        <div class="row text-right" dir="rtl" v-if="subcategory && category">
          <ul class="bread-crumb m-0">
            <li class="bread-crumb-item"><router-link to="/">نوراشاپ</router-link> / </li>
            <li class="bread-crumb-item"><router-link to="/category-list">فروشگاه</router-link> / </li>
            <li class="bread-crumb-item"><router-link :to="'/category/' + category.slug">{{category.name}}</router-link> / </li>
            <li class="bread-crumb-item"><router-link :to="'/sub-category/' + category.slug + '/' + subcategory.slug">{{subcategory.name}}</router-link> / </li>
            <li class="bread-crumb-item">{{strLimit(product_name,15)}}</li>
          </ul>
        </div>
        <hr>
        <div class="row" dir="rtl">
          <div class="col-lg-4 col-md-12 col-sm-12 col-12">
            <ProductImageCarousel
              id="carouselProduct"
              :mainImage="product_image"
              :mainImageAlt="product_name"
              :gallery="product ? product.gallery : []"
              :mediaUrl="$MEDIA"
            />
            <div class="mt-3 videodiv" v-if="product && product.video && product.videoCover">
              <video height="500" :poster="$MEDIA + product.videoCover" controls muted>
                <source :src="$MEDIA + product.video" type="video/mp4">
              </video>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-sm-12 col-12" dir="rtl">
            <h1 class="product-title mt-4 mb-0">{{product_name}}</h1>
            <p v-if="product" class="mb-4"><span class="special-tag" v-if="product.specialTag" dir="ltr">{{ product.specialTag }}</span></p>
            <div v-if="product" v-html="product.text"></div>
          </div>
          <div class="col-lg-4 col-md-12 col-sm-12 col-12 d-flex justify-content-center" v-if="product">
            <div class="position-relative pfix w-100">
              <div class="product-box p-3 m-3">
                <h6 class="mb-4">خرید محصول</h6>
                <div class="more-detail">
                  <p><i class="fa fa-shield mx-2 fs-15 gold" aria-hidden="true"></i><span>گارانتی اصالت و سلامت فیزیکی کالا</span></p>
                  <p><i class="fa fa-check mx-2 fs-15 green" aria-hidden="true" v-if="product.available === true"></i><span>محصول موجود در انبار</span></p>
                  <p><i class="fa fa-truck mx-2 fs-15 red" aria-hidden="true"></i><span>ارسال رایگان در تهران</span></p>
                  <p><i class="fa fa-eye mx-2 fs-15 blue"  aria-hidden="true"></i><span>{{product.view}} نفر مشاهده </span></p>
                  <p><i class="fa fa-barcode mx-2 fs-15"  aria-hidden="true"></i><span dir="ltr">{{product.id}} : کد محصول </span></p>
                </div>
                <div class="min-w mb-3" v-if="product.priceBeforeOff !== product.priceAfterOff && product.available === true && product.priceAfterOff != 0">
                  <p class="price m-0">
                    <span class="off" v-if="product.isOffInt">{{calPercentage(product.priceBeforeOff,product.priceAfterOff)}}%</span>
                    <del class="color-gray">{{product.priceBeforeOff.toLocaleString('fa')}}</del>
                    <span class="off" v-if="!product.isOffInt">حراج</span>
                  </p>
                  <p class="price m-0" dir="ltr"><span>{{product.priceAfterOff.toLocaleString('fa')}}</span><ToomanSvg /></p>
                </div>
                <div class="min-w mb-3" v-if="product.priceBeforeOff === product.priceAfterOff && product.available === true && product.priceAfterOff != 0">
                  <p class="price my-3" dir="ltr"><span>{{product.priceAfterOff.toLocaleString('fa')}}</span><ToomanSvg /></p>
                </div>
                <div class="min-w mb-3" v-if="product.available === true && product.priceAfterOff == 0">
                  <p class="price my-3 pointer" @click="checkPrice(product.id)" dir="ltr">قیمت را استعلام بگیرید</p>
                </div>
                <div class="min-w mb-3" v-if="product.available === false">
                  <p class="price my-3 pointer" @click="checkAvailable(product.id)" dir="ltr">محصول ناموجود می‌باشد، شارژ مجدد را استعلام بگیرید</p>
                </div>
                <div class="btns mobile-grid">
                  <hr>
                  <router-link :to="'/cam/' + product.slug" class="btn-add-cart purple mx-2" v-if="product.mlActivation">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-badge-ar" viewBox="0 0 16 16">
                      <path d="m3.794 11 .47-1.542H6.27L6.739 11H8L5.996 5.001H4.607L2.595 11zm1.503-4.852.734 2.426h-1.52l.734-2.426zm5.598-1.147H8.5V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9zm-1.222 2.87V5.933h1.05c.63 0 1.05.347 1.05.989 0 .633-.408.95-1.067.95z"/>
                      <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>
                    </svg>
                    دیدن با واقعیت افزوده
                  </router-link>
                  <button aria-label="افزودن به سبد خرید" v-if="product.available === true && product.priceAfterOff != 0 && product.concepts.length > 1" @click="addToCart(product, popup=false)" class="btn-add-cart mx-2" data-bs-toggle="modal" :data-bs-target="'#Concept'+product.id"><i class="fa-solid fa-shopping-cart"></i> افزودن به سبد</button>
                  <button aria-label="افزودن به سبد خرید" v-if="product.available === true && product.priceAfterOff != 0 && product.concepts.length <= 1" @click="addToCart(product)" class="btn-add-cart mx-2"><i class="fa-solid fa-shopping-cart"></i> افزودن به سبد</button>
                  <button aria-label="استعلام قیمت" v-if="product.available === true && product.priceAfterOff == 0" @click="checkPrice(product.id)" class="btn-add-cart mx-2"><i class="fa-solid fa-shopping-cart"></i> استعلام قیمت</button>
                  <button aria-label="استعلام" v-if="product.available === false" @click="checkAvailable(product.id)" class="btn-add-cart mx-2">استعلام</button>
                  <button aria-label="افزودن به علاقه‌مندی‌ها" @click="addToWish(product);product.isLike = !product.isLike" class="btn-product mx-2" v-if="!product.isLike"><i class="fa-solid fa-heart"></i></button>
                  <button aria-label="حذف از علاقه‌مندی‌ها" @click="removeFromWish(product);product.isLike = !product.isLike" class="btn-product mx-2" v-if="product.isLike"><i class="fa-solid fa-heart" style="color:red;"></i></button>
                  <hr>
                  <p>شما می توانید از پلتفرم های زیر نیز سفارش خود را ثبت کنید.</p>
                  <div class="d-flex">
                    <p class="mb-3"><a :href="`whatsapp://send?phone=+989384431548&text=درخواست سفارش محصول %0A https://nuorashop.ir/product/${category.slug}/${subcategory.slug}/${product.slug}`" class="btn-product-w color-black w-100"><i class="fab fa-whatsapp"></i></a></p>
                    <p class="mb-3"><a href="https://t.me/+989384431548" class="btn-product-t color-black w-100"><i class="fab fa-telegram"></i></a></p>
                  </div>
                </div>
              </div>
              <div class="product-box p-3 m-3" v-if="$User.isStaff">
                <h6 class="mb-4">باکس ادمین</h6>
                <hr>
                <div class="min-w mb-3">
                  <label for="priceAdmin">قیمت محصول</label>
                  <input type="number" id="priceAdmin" v-model="pf" class="form-control mb-3" placeholder="قیمت" />
                  <label for="hidePriceAdmin">قیمت مخفی محصول</label>
                  <input type="number" id="hidePriceAdmin" v-model="hpf" class="form-control mb-3" placeholder="قیمت" />
                  <button @click="changePrice()" class="btn-product color-black m-0" style="display: initial;padding: 11px;"> ثبت قیمت</button>
                </div>
                <hr>
                <div class="btns d-flex flex-wrap">
                  <button @click="changeAvailable()" v-if="product.available === false" class="btn-product-w color-black m-2" style="display: initial;padding: 11px;"> تبدیل به موجود</button>
                  <button @click="changeAvailable()" v-if="product.available === true" class="btn-add-cart m-2" style="display: initial;padding: 11px;">تبدیل به ناموجود</button>
                  <a :href="'/api/sua/shop/product/' + product.id + '/change/'" class="btn-django m-2" style="display: initial;padding: 11px;">ادمین جنگو</a>
                  <a :href="$MEDIA + product.image" target="_blank" class="btn-django m-2" style="display: initial;padding: 11px;">Open Image</a>
                  <router-link :to="'/product-fast-comment/' + product.slug" class="btn-django m-2" style="display: initial;padding: 11px;">تجربه خرید</router-link>
                </div>
                <hr>
                <div>
                  <CopyInput />
                </div>
              </div>
              <ShareBtn />
            </div>
          </div>
        </div>
        <hr>
        <div v-if="product">
          <div dir="rtl" v-for="pg in productGroup" :key="pg">
            <h2 class="my-4">{{ pg.title }}</h2>
            <ProductCarousel :objects="pg.products.filter(item => {return item.slug !== product.slug})"/>
          </div>
          <hr>
          <div class="mb-3 d-inline-block w-100" dir="rtl">
            <div class="top-stick bg-nav py-1">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <a aria-label="جدول توضیحات" class="nav-link p-2" @click.prevent="smoothScroll($event)" href="#b1">جدول توضیحات</a>
                </li>
                <li class="nav-item" role="presentation" v-if="product.giftText">
                  <a aria-label="هدیه" class="nav-link p-2" @click.prevent="smoothScroll($event)" href="#b2">هدیه</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a aria-label="نظرات" class="nav-link p-2" @click.prevent="smoothScroll($event)" href="#b4">نظرات</a>
                </li>
                <li class="nav-item" role="presentation" v-if="product.brand.slug">
                  <a aria-label="برند" class="nav-link p-2" @click.prevent="smoothScroll($event)" href="#b5">برند</a>
                </li>
              </ul>
            </div>
            <h2 class="my-4 section-tab" id="b1">جدول توضیحات</h2>
            <div class="tab-content" id="myTabContent1">
              <div class="container">
                <div class="description-tab" v-html="product.description"></div>
            </div>
            <h2 class="my-4 section-tab" v-if="product.giftText" id="b2">روانشناسی هدیه</h2>
              <div class="container">
                <div v-html="product.giftText"></div>
            </div>
            <hr>
              <h2 class="my-4 section-tab" id="b4">نظرات</h2>
                <div class="Comments container">
                    <div class="row" dir="rtl">
                        <div class="col-12 col-md-4 d-flex justify-content-center">
                          <div class="position-relative pfix w-100">
                            <div class="product-box p-3 m-3">
                              <lord-icon
                                  src="/img/icons/pojeargf.json"
                                  trigger="loop"
                                  delay="2000">
                              </lord-icon>

                              <h6 class="mb-4">برآیند محصول</h6>
                              <div class="more-detail">
                                <p>
                                  <span>
                                    <span class="icon" :class="product.rate >= 1 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="product.rate >= 2 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="product.rate >= 3 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="product.rate >= 4 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="product.rate >= 5 ? 'color-gold' : ''">★</span>
                                  </span>
                                </p>
                                <p><i class="fa fa-edit mx-2 fs-15 green" aria-hidden="true"></i><span>تعداد نظر ها : {{ comments.length }}</span></p>
                                <p><i class="fa fa-eye mx-2 fs-15 blue" aria-hidden="true"></i><span>بازدید : {{ product.view }}</span></p>
                                <p class="border-none"><i class="fa fa-layer-group mx-2 fs-15 gold" aria-hidden="true"></i><span>امتیاز : {{ product.score }}</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="formParent col-12 col-md-8" dir="rtl">
                            <p style="font-weight: 500;">امتیاز شما به این محصول</p>
                            <div class="rating">
                                <label>
                                    <input type="radio" v-model="stars" value="1" checked/>
                                    <span class="icon">★</span>
                                </label>
                                <label>
                                    <input type="radio" v-model="stars" value="2" />
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                </label>
                                <label>
                                    <input type="radio" v-model="stars" value="3" />
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                </label>
                                <label>
                                    <input type="radio" v-model="stars" value="4" />
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                </label>
                                <label>
                                    <input type="radio" v-model="stars" value="5" />
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                    <span class="icon">★</span>
                                </label>
                            </div>
                            <div class="form-outline mb-4" v-if="$User.isStaff">
                                <label class="form-label mb-3" for="name">نام</label>
                                <input placeholder="نام نظر دهنده را بنویسید" type="text" v-model="name" id="name" class="form-control" />
                            </div>
                            <div class="form-outline mb-4">
                                <label class="form-label" for="comment-text">متن نظر شما</label>
                                <textarea placeholder="متن نظر را بنویسید" type="text" v-model="commenttext" id="comment-text" class="form-control"></textarea>
                            </div>
                            <small class="form-text text-muted">نظر ها برسی خواهند شد و در صورت داشتن مفاهیم نامربوط حذف می‌شوند.</small>
                            <div>
                                <button aria-label="ثبت" v-if="$isAuthenticated" @click="sendComment()" class="btn btn-block mt-3">ثبت </button>
                                <button aria-label="ثبت" v-if="!$isAuthenticated" data-bs-toggle="modal" data-bs-target="#login-modal" class="btn btn-block mt-3">ثبت </button>
                            </div>
                            <div class="mt-5 mb-5" dir="rtl">
                                <h3 class="commentsHeader">
                                    نظرات کاربران
                                </h3>
                            </div>
                            <Transition>
                            <div v-if="this.comments.length == 0" class="container text-right mb-5">
                                <div class="page404 m-5">
                                    <h6 class="no-result-search">نظری ثبت نشده است</h6>
                                </div>
                            </div>
                            </Transition>
                            <div class="CommentParent alert alert-danger" dir="rtl" :key="a" v-for="a in unpublish">
                                <p class="commentsText">
                                  {{a.profile}}
                                  <span>
                                    <span class="icon" :class="a.rate >= 1 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="a.rate >= 2 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="a.rate >= 3 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="a.rate >= 4 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="a.rate >= 5 ? 'color-gold' : ''">★</span>
                                  </span>
                                  (در انتظار تایید)
                                </p>
                                <p class="commentsTextChild">
                                    {{a.text}}
                                </p>
                                <p class="commentsTextChild">
                                    {{a.date}}
                                </p>
                            </div>
                            <div class="CommentParent" dir="rtl" :key="a" v-for="a in comments">
                                <p class="commentsText">
                                  {{a.profile}}
                                  <span>
                                    <span class="icon" :class="a.rate >= 1 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="a.rate >= 2 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="a.rate >= 3 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="a.rate >= 4 ? 'color-gold' : ''">★</span>
                                    <span class="icon" :class="a.rate >= 5 ? 'color-gold' : ''">★</span>
                                  </span>
                                </p>
                                <p class="commentsTextChild">
                                    {{a.text}}
                                </p>
                                <p class="commentsTextChild">
                                    {{a.date}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <h2 class="my-4 section-tab" id="b5" v-if="product.brand.slug">برند</h2>
              <div v-if="product.brand.slug">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-2 col-md-12 col-12 d-flex">
                      <div class="text-center shadow-hover m-auto">
                          <router-link class="twkc" :to="'/brand/' + product.brand.slug">
                              <img class="brand-img bg-brand mb-3" v-lazy="$MEDIA + product.brand.image" :alt="product.brand.name">
                              <p>{{product.brand.name}}</p>
                          </router-link>
                      </div>
                    </div>
                    <div class="col-lg-10 col-md-12 col-12">
                      <div class="mt-3 mb-5" v-if="product">
                        <BlogCarousel :objects="product.brand.blogs" />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="mt-3 mb-5" v-if="showCollections">
                        <CollectionCarousel :collections="collections" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="my-3">
            <hr>
            <ul class="nav nav-tabs my-4" dir="rtl" id="myTabAi" role="tablist">
              <li class="nav-item" role="presentation">
                <button aria-label="محصولات مشابه" class="nav-link text-end active" data-bs-toggle="tab" data-bs-target="#c" type="button" role="tab">
                  محصولات مشابه
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="30" height="30">
                    <!-- Square Box -->
                    <rect x="10" y="10" width="80" height="80" fill="#007BFF" stroke="#0056b3" stroke-width="3" />
                    <!-- Text -->
                    <text x="50" y="60" text-anchor="middle" font-family="Arial, sans-serif" font-size="45" fill="#FFFFFF" font-weight="bold">
                      AI
                    </text>
                  </svg>
                </button>
              </li>
              <li class="nav-item" role="presentation" v-if="product.similar.length > 5">
                <button :aria-label="product.similarTitle" class="nav-link text-end" data-bs-toggle="tab" data-bs-target="#c1" type="button" role="tab">{{product.similarTitle}}</button>
              </li>
              <li class="nav-item" role="presentation" v-if="product.suggest.length > 5">
                <button :aria-label="product.suggestTitle" class="nav-link text-end" data-bs-toggle="tab" data-bs-target="#c2" type="button" role="tab">{{product.suggestTitle}}</button>
              </li>
              <template v-for="(collection, index) in suggestCollections" :key="(collection, index)">
                <li class="nav-item" role="presentation" v-if="collection.suggestProducts.length > 5">
                  <button :aria-label="collection.name" class="nav-link text-end" data-bs-toggle="tab" :data-bs-target="'#sc' + collection.id" type="button" role="tab">{{collection.name}}</button>
                </li>
              </template>
            </ul>
            <div class="tab-content" id="myTabContent2">
              <div class="tab-pane fade show active" id="c" role="tabpanel">
                <ProductCarousel :objects="mlProducts"/>
              </div>
              <div class="tab-pane fade show" id="c1" role="tabpanel">
                <ProductCarousel :objects="product.similar" v-if="product.similar.length >= 4"/>
              </div>
              <div class="tab-pane fade show" id="c2" role="tabpanel">
                <ProductCarousel :objects="product.suggest" v-if="product.suggest.length >= 4"/>
              </div>
              <div class="tab-pane fade show" :id="'sc' + collection.id" role="tabpanel" v-for="(collection, index) in suggestCollections" :key="(collection, index)">
                <ProductCarousel :objects="collection.suggestProducts" v-if="collection.suggestProducts.length > 5"/>
              </div>
            </div>
          </div>
          <FaqBox :objs="product.faqs" class="my-4" />
          <ConceptModal :objects="product.concepts" :product="product.id" v-if="product.concepts.length > 0" :selectItem="true" />
        </div>
      </div>
      <div v-show="!product">
        <PreLoad />
      </div>
    </div>
</template>
<script>
import ShareBtn from '@/components/ShareBtn.vue'
import FaqBox from '@/components/FaqBox.vue'
import ProductCarousel from '@/components/ProductCarousel.vue'
import CollectionCarousel from '@/components/CollectionCarousel.vue'
import ConceptModal from '@/components/ConceptModal.vue'
import CopyInput from '@/components/epay/CopyInput.vue'
import BlogCarousel from '@/components/BlogCarousel.vue'
import PageNotFound from '@/views/site/PageNotFound.vue'
import ProductImageCarousel from '@/components/ProductImageCarousel.vue'
import PreLoad from '@/components/PreLoad.vue'

export default {
  name: 'ProductPage',
  components: {
    FaqBox,
    ShareBtn,
    ProductCarousel,
    CollectionCarousel,
    ConceptModal,
    CopyInput,
    BlogCarousel,
    PageNotFound,
    ProductImageCarousel,
    PreLoad
  },
  data () {
    return {
      product: null,
      pf: 0,
      hpf: 0,
      comments: [],
      unpublish: [],
      commenttext: null,
      stars: 3,
      category: null,
      subcategory: null,
      collections: [],
      suggestCollections: [],
      names: [],
      name: '',
      showCollections: true,
      mlProducts: null,
      productGroup: null,
      document: document,
      product_name: document.querySelector('meta[name=\'product-name\']')?.content,
      product_image: document.querySelector('meta[name=\'og:image\']')?.content
    }
  },
  methods: {
    changeAvailable: function () {
      const mutation = `
        mutation {
          toggleAvailable(
            id: ${this.product.id}
          ){
            success
          }
        }
      `
      this.$fetchGraphQL(mutation).then(response => {
        if (response.data.toggleAvailable.success) {
          this.product.available = !this.product.available
        }
      })
    },
    changePrice: function () {
      if (this.hpf === '' || this.pf === '') {
        this.fire({
          icon: 'error',
          title: 'هر دو مقدار باید پر باشد',
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        const mutation = `
          mutation {
            productSetPrice(
              id: ${this.product.id}
              price: ${this.pf}
              hidePrice: ${this.hpf}
            ){
              success
            }
          }
        `
        this.$fetchGraphQL(mutation).then(response => {
          if (response.data.productSetPrice.success) {
            this.fire({
              icon: 'success',
              title: 'ثبت شد',
              showConfirmButton: false,
              timer: 2000
            }).then((e) => {
              this.pageLoad()
            })
          }
        })
      }
    },
    sendComment: function () {
      if (!this.commenttext) {
        this.fire({
          icon: 'error',
          title: 'متن نظر را کامل کنید.',
          showConfirmButton: false,
          timer: 2000
        })
      } else {
        const mutation = `
          mutation productComment {
            productComment(name: "${this.name}", pk:${this.product.id}, rate: ${this.stars}, text:"${this.commenttext}") {
              status
              addWallet
            }
          }
        `
        this.$fetchGraphQL(mutation).then(response => {
          if (response.data.productComment.status === 'success') {
            this.unpublish.push({ profile: this.name || this.$User.name, text: this.commenttext, rate: this.stars, date: 'چند لحظه پیش' })
            this.stars = 3
            this.commenttext = ''
            if (response.data.productComment.addWallet) {
              this.fire({
                icon: 'success',
                title: 'ثبت شد',
                text: `مبلغ ${response.data.productComment.addWallet} تومان به حساب کاربری شما افزوده شد.`,
                showConfirmButton: false,
                timer: 2500
              })
              const user = JSON.parse(localStorage.getItem('User'))
              user.wallet += response.data.productComment.addWallet
              localStorage.setItem('User', JSON.stringify(user))
              this.$User = user
            } else {
              this.fire({
                icon: 'success',
                title: 'ثبت شد',
                showConfirmButton: false,
                timer: 1500
              })
            }
          } else {
            this.fire({
              icon: 'error',
              title: 'اشکالی به وجود آمده',
              showConfirmButton: false,
              timer: 2000
            })
          }
        })
      }
    },
    removeA: function (arr) {
      // eslint-disable-next-line
      var what, a = arguments, L = a.length, ax
      while (L > 1 && arr.length) {
        what = a[--L]
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1)
        }
      }
      return arr
    },
    pageLoad: function () {
      const firstSlide = document.querySelector('#carouselProduct [data-bs-slide-to="0"]')
      if (firstSlide) {
        firstSlide.click()
      }
      this.category = this.$categories.filter(item => item.slug === this.$route.params.category)[0]
      this.subcategory = this.category.subcategories.filter(item => item.slug === this.$route.params.subcategory)[0]
      const query = `{
        productGroup(slug: "${this.$route.params.slug}") {
          title
          products {
            available
            slug
            name
            image: PNG
            mlActivation
            specialTag
            concepts: concepts {
              id
              price
              name
              video
              videoCover
              image
              description
            }
            isOffInt
            priceAfterOff
            priceBeforeOff
            categorySlug
            subCategorySlug
            categoryId
          }
        }
        product:productBySlug(slug:"${this.$route.params.slug}"){
          id,
          index,
          categorySlug,
          subCategorySlug,
          canonical,
          seoTitle,
          seoKeyword,
          seoDescription,
          available,
          slug,
          name,
          view,
          alt,
          similarTitle:similarTitle,
          suggestTitle:suggestTitle,
          brand { slug, name, image, blogs { slug, image, name, description, category, rates } },
          image:PNG,
          mlActivation,
          specialTag,
          isOffInt,
          priceAfterOff,
          priceBeforeOff,
          faqs {
            id
            name
            text
          }
          similar { 
            id,
            available,
            slug,
            name,
            image:PNG,
            alt,
            categoryId:categoryId,
            subCategoryId,
            categorySlug,
            subCategorySlug,
            isOffInt,
            priceAfterOff,
            priceBeforeOff,
          },
          suggest { 
            id,
            available,
            slug,
            name,
            image:PNG,
            alt,
            categoryId:categoryId,
            subCategoryId,
            categorySlug,
            subCategorySlug,
            isOffInt,
            priceAfterOff,
            priceBeforeOff,
          },
          gallery { img },
          concepts { video, videoCover, image, description, name, price },
          video,
          videoCover,
          text,
          description,
          giftText:giftText,
          score,
          hpf,
          pf
        },
        collections:collections(filters:{
          brandByProduct:"${this.$route.params.slug}"
        }){
          slug,
          description,
          name,
          image,
        },
        productCollections:collections(filters:{
          product:"${this.$route.params.slug}"
        }){
          id,
          name,
          suggestProducts:suggestProducts {
            id,
            available,
            slug,
            name,
            image:PNG,
            alt,
            categoryId:categoryId,
            subCategoryId,
            categorySlug,
            subCategorySlug,
            isOffInt,
            priceAfterOff,
            priceBeforeOff,
          }
        },
        comments:productComments(slug:"${this.$route.params.slug}"){
          id,
          rate,
          text,
          profile,
          date
        },
        commentsUnpublish:productCommentsUnpublish(slug:"${this.$route.params.slug}"){
          id,
          rate,
          text,
          profile,
          date
        },
        commentsMore:productCommentsMore(slug:"${this.$route.params.slug}"){
          id,
          rate,
          text,
          profile,
          date
        },

        }
      `
      this.$fetchGraphQL(query)
        .then((res) => {
          this.product = res.data.product || '404'
          this.product_name = this.product.name
          this.product_image = this.$MEDIA + this.product.image
          this.productGroup = res.data.productGroup
          this.product.isLike = JSON.parse(localStorage.getItem('wish')) ? JSON.parse(localStorage.getItem('wish'))[this.product.id] : false
          this.pf = this.product.pf
          this.hpf = this.product.hpf
          this.setMetaByObj(this.product)
          this.collections = res.data.collections
          if (this.collections.length === 0) {
            this.showCollections = false
          }
          this.comments = res.data.comments.concat(res.data.commentsMore)
          this.unpublish = res.data.commentsUnpublish
          const sc = res.data.productCollections
          const similarIds = this.product.similar.map((i) => i.id)
          const suggestIds = this.product.suggest.map((i) => i.id)
          for (const x in sc) {
            const HaveToRemove = []
            for (const y in sc[x].suggestProducts) {
              const id = sc[x].suggestProducts[y].id
              if (similarIds.includes(id) || suggestIds.includes(id)) {
                HaveToRemove.push(sc[x].suggestProducts[y])
              }
            }
            for (const h in HaveToRemove) {
              this.removeA(sc[x].suggestProducts, HaveToRemove[h])
            }
          }
          this.suggestCollections = sc
        })
        .catch((error) => {
          console.log(error)
        })
      const query2 = `
      {
        similarProduct(slug: "${this.$route.params.slug}") {
          id,
          available,
          slug,
          name,
          image:PNG,
          alt,
          categoryId:categoryId,
          subCategoryId,
          categorySlug,
          subCategorySlug,
          isOffInt,
          priceAfterOff,
          priceBeforeOff,
        }
      }
      `
      this.$fetchGraphQL(query2).then(res => {
        this.mlProducts = res.data.similarProduct
      })
    },
    calPercentage: function (before, after) {
      const percentage = parseInt((before - after) * 100 / before)
      return percentage.toLocaleString('fa')
    },
    scrollTabs: function () {
      const links = document.querySelectorAll('ul[role="tablist"] a')
      const sections = document.querySelectorAll('.section-tab')
      let currentSection = ''
      sections.forEach(section => {
        const sectionTop = section.offsetTop
        const sectionHeight = section.offsetHeight
        if (window.scrollY >= sectionTop - sectionHeight - 200) {
          currentSection = section.getAttribute('id')
        }
      })

      links.forEach(link => {
        link.classList.remove('active')
        if (link.getAttribute('href') === `#${currentSection}`) {
          link.classList.add('active')
        }
      })
    },
    smoothScroll: function (event) {
      const targetId = event.target.getAttribute('href').substring(1)
      const targetElement = document.getElementById(targetId)

      if (targetElement) {
        const targetPosition = targetElement.offsetTop - 135

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        })
      }
    }
  },
  mounted () {
    this.pageLoad()
    window.addEventListener('scroll', this.scrollTabs)
    this.scrollTabs()
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.scrollTabs)
  },
  watch: {
    '$route.params.slug' (to, from) {
      if (this.$route.path.slice(1, 9) === 'product/') {
        this.mlProducts = null
        this.pageLoad()
      }
    }
  }
}
</script>

<style scoped>
.btn-concept{
  border-radius: 16px;
  font-size: 10pt;
}

.change{
  font-size: small;
  background: antiquewhite;
}
.border-none{
  border: none !important;
}
.fs-15{
  font-size: 15px !important;
}
.more-detail > p {
  color: #464b54;
  border-bottom: solid 1px #d7d6d6;
  padding-bottom: 13px;
}
.videodiv{
  margin: 0px;
  background: #ebebeb;
  border-radius: 24px;
}
.color-gold{
  color: gold;
}
.l-img{
  width: 300px;
  height: min-content;
}
textarea {
  height: 150px;
  border-radius: 16px;
}
.rating {
  display: inline-block;
  position: relative;
  height: 50px;
  line-height: 50px;
  font-size: 50px;
}
.rating label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  cursor: pointer;
}
.rating label:last-child {
  position: static;
}
.rating label:nth-child(1) {
  z-index: 5;
}
.rating label:nth-child(2) {
  z-index: 4;
}
.rating label:nth-child(3) {
  z-index: 3;
}
.rating label:nth-child(4) {
  z-index: 2;
}
.rating label:nth-child(5) {
  z-index: 1;
}
.rating label input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.rating label .icon {
  float: left;
  color: transparent;
}
.rating label:last-child .icon {
  color: rgb(173, 173, 173);
}
.rating:not(:hover) label input:checked ~ .icon,
.rating:hover label:hover input ~ .icon {
  color: gold;
}
.rating label input:focus:not(:checked) ~ .icon:last-child {
  color: rgb(173, 173, 173);
  text-shadow: 0 0 5px gold;
}
.dot2{
  height: 6px;
  width: 6px;
  margin: 0px 10px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
.CommentParent{
  margin-bottom:24px;
  padding-bottom:24px;
  border-bottom:1px solid #E0E0E0 ;
}
.commentsHeader{
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 40px;
  text-align: right;
  color: #828282;
  border-right:5px solid #86e9fc;
  padding-right:16px;
  margin-bottom:16px;
}
.commentsText{
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  align-items: center;
  text-align: justify;
  color: #121212;
  margin-bottom:24px;
}
.commentsTextChild{
  margin-right:40px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  align-items: center;
  color: #121212;
}
img{
  width: 100%;
}
.pfix {
  top: 126px;
  float: left;
  position: -webkit-sticky;
  position: sticky!important;
  -ms-flex-item-align: start;
  align-self: flex-start;
  margin-bottom: 40px;
  -webkit-transition: top .3s ease;
  transition: top .3s ease;
}
.off{
  font-weight: bold;
  background: #b4aaf3;
  color: black;
  padding: 5px 15px;
  margin-right: 5px;
  line-height: 50px;
  border-radius: 16px;
}
.special-tag{
  font-weight: bold;
  background: #a37e2c;
  color: white;
  padding: 5px 15px;
  margin-right: 5px;
  line-height: 50px;
  border-radius: 16px;
}
.min-w{
  min-width: 100px;
}
.btn-product{
  background-color: #d8d8d8;
  border-radius: 24px;
  border: none;
  padding:15px;
  margin-bottom: 1rem;
  display: inline-grid;
  border-radius: 16px;
  font-size: 13px;
  text-align: center;
}
.btn-product-w{
  background: #65aa57;
  border-radius: 24px;
  border: solid 1px #e0e0e2;
  padding:15px;
  display: block;
  border-radius: 16px;
  color: white;
  font-size: 13px;
  text-align: center;
  font-weight: bold;
}
.btn-product-t{
  background: #0088cc  ;
  border-radius: 24px;
  border: solid 1px #e0e0e2;
  padding:15px;
  display: block;
  border-radius: 16px;
  color: white;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.btn-product-b{
  background: #00b894  ;
  border-radius: 24px;
  border: solid 1px #e0e0e2;
  padding:15px;
  display: block;
  border-radius: 16px;
  color: white;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.btn-add-cart{
  display: initial;
  padding: 11px;
  margin-bottom: 1rem;
  background: #ef4056;
  border-radius: 16px;
  font-weight: bold;
  border: none;
  color: white;
  font-size: 14px;
  text-align: center;
}
.btn-django{
  background: green;
  border-radius: 16px;
  font-weight: 400;
  border: none;
  color: white;
  font-size: 13px;
  text-align: center;
}
#carouselProduct{
  width: -webkit-fill-available;
  margin: 0px;
}
.carousel-indicators [data-bs-target]{
  background-color: #575757;
}
.fa{
  font-size: 25px;
}
.fab{
  font-size: 16pt;
}
.product-title{
  font-size: 16pt;
}
.price{
  font-style: normal;
  font-weight:bold;
  font-size: 15px;
  line-height: 162%;
  text-align: right;
  font-family:"IRANSans";
  text-align: left;
}
.product-box{
  min-width: 250px;
  border-radius:16px;
  background: linear-gradient(0deg,hsla(240,3%,94%,.5),hsla(240,3%,94%,.5)),#fff;
  border: solid 1px #e0e0e2;
}
@media (max-width:768px)  {
  #carouselProduct{margin:0 !important;}
  .mobile-grid{
    display: grid;
  }
}
.nav-link{
  color: #bdbdbd;
}
.nav{
  justify-content: start;
}
.nav-link{
  margin-bottom: 5px;
  color: #83878e;
  width: auto;
}
.nav-link:hover{
  border-color: transparent;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active{
  color: #4285f4;
  border-color: transparent;
  border-bottom: solid;
  border-radius: 16px;
}
.nav-tabs{
  border:none;
  padding: 0;
}
.brand-img{
  border-radius: 24px 20px 0px 0px;
  aspect-ratio: 1/1;
}
.drop-shadow{
  filter: drop-shadow(0px 2px 5px rgba(50, 50, 0, 0.2));
}
.title-c{
  color: white;
  background: #808080b3;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 12px;
}
.brand-name{
    border: solid #e8acd4 2px;
    color: black;
    padding: 10px;
    border-radius: 24px;
    width: max-content;
}
.margin-brand{margin: 15px 6px;width: 220px;}
.bg-brand{
  background-image: url('../../assets/brand.jpg')!important;
  background-size: cover;
  padding: 20%;
  border-radius:16px;
}
.shadow-hover{
  border: solid 1px #d1d1d1;
  border-radius: 16px;
  transition: 0.4s;
}
.shadow-hover:hover{
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px white;
}
.fs-13{
  font-size: 16pt !important;
}
.top-stick {
  position: -webkit-sticky;
  position: sticky;
  top: 76px;
  z-index: 8;
  background-color: #fff;
  border-radius: 16px;
}
@media only screen and (max-width:992px){
  .top-stick{
    top: 66px;
    height: 52px;
  }
  .top-stick ul {
    width: 400px;
    white-space: nowrap;
  }
  .top-stick li {
    display: inline-block;

    /* if you need ie7 support */
    display: inline;
    zoom: 1;
  }
}
.product-image{
  aspect-ratio: 1/1;
}
</style>
